module.exports = __webpack_public_path__ + "static/media/02b0fe47.jpg";